import { Box, Button, Typography, styled } from '@mui/material';

import { flexMixin } from 'utils/flexMixin';

import { titleTextColor } from 'assets/styles/_palette';

export const InfoBox = styled(Box)({
	...flexMixin({ align: 'flex-start', direction: 'column', gap: 12 }),
	width: '100%',
});

export const InfoTitle = styled(Typography)({
	color: '#1A1C1C',
	fontSize: '16px',
	fontStyle: 'normal',
	fontWeight: 700,
	lineHeight: '157%',
	letterSpacing: '0.1px',
});

export const InfoContent = styled(Box)({
	padding: '16px',
	borderRadius: '8px',
	background: 'rgba(236, 243, 255, 0.50)',
	width: '100%',
	boxSizing: 'border-box',
});

export const SubscriptionButtons = styled(Box)({
	...flexMixin({ align: 'flex-end', direction: 'column' }),
});

export const SubscriptionButton = styled(Button)({
	backgroundColor: 'unset',
	color: '#4786FF',
	fontSize: '16px',
	fontWeight: '700',
	lineHeight: ' 157%',
	letterSpacing: '0.1px',
	borderRadius: '8px',
	padding: '10px 16px',
	textTransform: 'unset',
});

export const SubscriptionInfo = styled(Box)({
	...flexMixin({ align: 'flex-start', direction: 'column', gap: 8 }),
	maxWidth: '545px',
});

export const SimpleSubscriptionDescription = styled(Typography)({
	marginLeft: '8px',
	color: '#1A1C1C',
	fontSize: '16px',
	fontStyle: 'normal',
	fontWeight: 700,
	lineHeight: '157%',
	letterSpacing: '0.1px',
});

export const SubscriptionDescription = styled(Typography)({
	fontSize: '16px',
	fontWeight: '400',
	lineHeight: ' 150%',
	letterSpacing: '0.15px',
	color: 'rgb(112, 122, 142)',
});

export const Subscription = styled(Box)({
	...flexMixin({ justify: 'space-between' }),
	width: '100%',
});

export const ActiveSubscriptionTitle = styled(Typography)({
	fontSize: '20px',
	fontWeight: '700',
	lineHeight: ' 160%',
	letterSpacing: '0.15px',
	color: titleTextColor,
});

export const BillingTitle = styled(Typography)({
	fontSize: '16px',
	fontWeight: '400',
	lineHeight: ' 150%',
	letterSpacing: '0.15px',
	color: '#1A1C1C',
});

export const PaymentInfo = styled(Box)({
	...flexMixin({ gap: 5 }),
});
